<div class="flex-fill overflow-hidden h-100">
  <div class="d-flex flex-column h-100">
    <div class="tabs-listing">
      <ul>
        <li (click)="onTabChange(SpecLotsAndModelsTabs.Overview)">
          <a href="javascript:void(0)" [ngClass]="{ active: activeTabIndex() === SpecLotsAndModelsTabs.Overview }"
            ><i class="bi bi-grid"></i>Overview</a
          >
        </li>
        @if (specLot()?.lotTypeId !== LotType.Reg) {
          <li (click)="onTabChange(SpecLotsAndModelsTabs.Options)">
            <a href="javascript:void(0)" [ngClass]="{ active: activeTabIndex() === SpecLotsAndModelsTabs.Options }"
              ><i class="bi bi-sliders"></i>Options</a
            >
          </li>
        }
      </ul>
    </div>
    <div class="tabs-listing-content flex-fill overflow-y-auto">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
